<template>
    <div class="vol-el-menu-item">
        <template v-for="(item, index) of list">
            <el-menu-item :key="index"
                :index="''+item.id"
                v-if="!item.children.length&&item.enable==1">
                    <span slot="title"> {{ item.name }}</span>
            </el-menu-item>
            <el-submenu :key="index"
                :index="''+item.id"
                v-if="item.children.length&&item.enable==1">
                    <template slot="title">
                        <span> {{ item.name }}</span>
                    </template>
                    <maliang-element-menu-child :list="item.children" />
            </el-submenu>
        </template>
    </div>
</template>

<script>
export default {
     name: 'maliang-element-menu-child',
     props:{
         list:Array
     }
}
</script>

<style scoped>
.vol-el-menu-item >>> .el-menu-item {
    height: 42px !important;
    line-height: 42px !important;
}
</style>